
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStateContext } from '../context/authContext';

function useRequireAuth({ children }){
    
    const location = useLocation();
    const { token } = useAuthStateContext();
    
    if (!token) {
        return <Navigate to='/login' state={{ from: location.pathname }} />
    }
    
    return children
}

export default useRequireAuth;